export const localeColumns = {
  logo: { ru: "log_url_ru", en: "log_url_en" },
  name: { ru: "name", en: "name_en" },
  activity: { ru: "name", en: "nameEn" },
  country: { ru: "countryName", en: "countryNameEn" },
  pavilion: { ru: "pavilion", en: "pavilion" },
  stend: { ru: "stend", en: "stend" }
}
